import PropTypes from 'prop-types';
import * as R from 'ramda';
import React  from 'react';
import {createRender} from 'react-render-callback';

/** A component used to forms into logical sections.
 *
 * Can be used to implement lazy rendering inside it.
 * Also acts as a way to transform valuePath scope (See FormContext.jsx)
 * so that subforms can be scoped to different value paths.
 *
 * props:
 * valuePath: scope all the children of this form inside a valuePath.
 * pure: if true, only rerender when the values in the given valuePath have changed
 *
 * Example:
 *
 * <FormContext valuePath="dog">
 *  <Input valuePath="name" />
 *  <Input valuePath="age" />
 *  </FormContext>
 *
 *  is equivalent to
 *  <Input valuePath="dog.name" />
 *  <Input valuePath="dog.age" />
 *
 */
export class FormSection extends React.Component {
  static contextTypes = {
    formApi: PropTypes.object.isRequired,
  };
  static childContextTypes = {
    formApi: PropTypes.object.isRequired,
  };
  static defaultProps = {
    valuePath: [],
    pure: false
  };
  formApi = getScopedFormApi(this.context.formApi, this.props.valuePath);
  getChildContext = () => {
    return {formApi: this.formApi};
  };
  shouldComponentUpdate(nextProps) {
    if (!this.props.pure) return true;
    if (!R.equals(R.dissoc("children", nextProps), R.dissoc("children", this.props))) return true;
    return this.formApi.hasChanged([]);
  }
  render() {
    const values = this.formApi.getValue([]);
    return createRender(this.props.children)(values, this.formApi);
  }
}

function getScopedFormApi(formApi, valuePath) {
  return R.mergeRight(formApi, {
    getValue: (key) => formApi.getValue([valuePath, key]),
    setValue: (key, value) => formApi.setValue([valuePath, key], value),
    updateValue: (key, updater) => formApi.updateValue([valuePath, key], updater),
    hasChanged: (key) => formApi.hasChanged([valuePath, key]),
  });
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/FormSection.jsx